export const IMPORTED_MODEL_RUNTIME_CACHE_REVISION = '2026-05-19-imported-brep-worker-baseline-v1'
